import ProductTemplateDetailApp from "ProductTemplate/Detail/App";
import ProductTemplateList from "ProductTemplate/List/App";
import ProductTemplateNewApp from "ProductTemplate/New/App";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const productTemplateRoute: RouteObject = {
  path: "producttemplate",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: ProductTemplateList,
  }, {
    path: "new",
    loader: () => viewModel,
    Component: ProductTemplateNewApp,
  }, {
    path: ":key",
    loader: () => viewModel,
    Component: ProductTemplateDetailApp,
  }]
};